import type { Callout } from '@/lib/schemas/db'

export type CalloutStatus = Callout['status']

export const calloutStatusOrder: CalloutStatus[] = [
  'New',
  'Booked',
  'LeftSite',
  'Arrived',
  'Started',
  'Ended',
  'Blocked',
  'Review',
  'ReadyToInvoice',
  'Invoiced',
  'Cancelled',
]

export const calloutStatusDescriptions: Record<CalloutStatus, string> = {
  New: 'Created but not yet booked.',
  Booked: 'Scheduled with a date/time.',
  LeftSite: 'Technician has left the site.',
  Arrived: 'Technician has arrived and work is in progress.',
  Started: 'Work has started and is in progress.',
  Ended: 'Work has ended and is ready for review or invoicing.',
  Blocked:
    'Work is paused, waiting on something (parts, customer, approval). A reason is recorded.',
  Review:
    'Work is done but needs checking, clarification, or admin follow-up before invoicing.',
  ReadyToInvoice: 'Work is complete and all billables/notes are captured.',
  Invoiced:
    'Invoicing is completed. The callout becomes read-only (except an admin move back to Review).',
  Cancelled: 'The callout will not take place (can be re-booked later).',
}

export const calloutStatusTransitions: Record<
  CalloutStatus,
  CalloutStatus[]
> = {
  New: ['Booked', 'Cancelled'],
  Booked: ['Arrived', 'Cancelled'],
  Arrived: ['LeftSite', 'ReadyToInvoice', 'Cancelled'],
  LeftSite: ['Review', 'ReadyToInvoice', 'Cancelled'],
  Started: ['Ended', 'ReadyToInvoice', 'Cancelled'],
  Ended: ['Review', 'ReadyToInvoice', 'Cancelled'],
  // Blocked's onward transitions are supplied by withUniversalTransitions.
  Blocked: [],
  Review: ['Arrived', 'ReadyToInvoice', 'Cancelled'],
  ReadyToInvoice: ['Invoiced', 'Review', 'Cancelled'],
  Invoiced: ['Review'],
  Cancelled: ['Booked'],
}

export function formatCalloutStatus(value: CalloutStatus): string {
  if (value === 'ReadyToInvoice') return 'Ready to Invoice'
  if (value === 'Arrived') return 'Arrived on site'
  if (value === 'LeftSite') return 'Left site'
  if (value === 'Started') return 'Started'
  if (value === 'Ended') return 'Ended'
  return value
}
